import {LocationFragment} from "@services/graphql/queries/location";

export const maybeGetLocationWithSpecialtyHours = (
  location: LocationFragment,
  specialtyId?: string,
) => {
  const {locationSpecialties} = location;

  const specialtyHours = locationSpecialties?.find(s => s?.specialtyId === specialtyId)?.hours;
  return (
    (specialtyId &&
      specialtyHours && {
        ...location,
        specialties: {
          [specialtyId]: {
            hours: specialtyHours,
          },
        },
      }) ||
    location
  );
};
